module.exports = __webpack_public_path__ + "img/sign.7cea0f06.gif";